import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { IssueStatusDescription } from '../../../../components/entities/IssueStatus'
import CreateIssueForm from '../AdminCreateIssueForm'
import { EditIssueForm } from './AdminEditIssueForm'
import { AdminEditEntityWrapper } from '../../shared/AdminEditEntityWrapper'
import { IssueSingleItem } from '@finance-lab/utils/types'

function AdminIssueForm() {
    const { t } = useTranslation()
    const { issueId } = useParams()
    const [issue, setIssue] = useState<IssueSingleItem | null>(null)

    useEffect(() => {
        if (issueId === 'new') {
            setIssue(null)
        }
    }, [issueId]) // reset company name when creating a new issue

    return (
        <AdminEditEntityWrapper
            companyId={issue?.companyId}
            entityLink={`/issues/${issue?.id}`}
            entityStatus={
                issue && (
                    <IssueStatusDescription
                        hideUntil={issue.statusHideUntil}
                        stage={issue.statusStage}
                        isComplete={issue.statusComplete}
                    />
                )
            }
            pageTitle={t('site.issues.detailsTitle', { name: issue?.companyName }) || ''}
        >
            <Card sx={{ marginBottom: 6 }}>
                <CardContent>
                    {issueId === 'new' && <CreateIssueForm />}
                    {issueId !== 'new' && <EditIssueForm onChangeIssue={setIssue} issueId={issueId} />}
                </CardContent>
            </Card>
        </AdminEditEntityWrapper>
    )
}

export default AdminIssueForm
